(function () {
'use strict';
if (window.vtModel) return;
window.vtModel = true;

var stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function data() {
  var el = document.querySelector('[data-vt-model-data]');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
}
function alle(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

function badges(d, sleutel) {
  var grid = document.querySelector('.vt-model .vt-mgrid');
  if (!grid) return;
  grid.querySelectorAll('.vt-mbadge').forEach(function (b) { b.remove(); });
  if (!sleutel || !d.badges) return;
  var gedaan = [];
  grid.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
    var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0];
    var per = d.badges[h];
    if (!per || !per[sleutel]) return;
    var kaart = a.closest('.vt-pc') || a.closest('article, li') || a.parentElement;
    if (!kaart || gedaan.indexOf(kaart) > -1) return;
    gedaan.push(kaart);
    var delen = per[sleutel].split('|');
    var span = document.createElement('span');
    span.className = 'vt-mbadge' + (delen[1] === 'half' ? ' vt-mbadge--half' : '');
    span.textContent = d.badge.replace('[kw]', delen[0] + ' kW');
    (kaart.querySelector('.vt-pc__body, .vt-pc__info, .vt-pc__content, .vt-pc__t') || kaart).appendChild(span);
  });
}

function kies(waarde) {
  var d = data();
  if (!d) return;
  var jouw = d.uitv && Object.prototype.hasOwnProperty.call(d.uitv, waarde) ? waarde : null;
  alle('.vt-model [data-v]').forEach(function (el) { el.classList.toggle('is-jouw', el.getAttribute('data-v') === jouw); });
  badges(d, jouw);
}

document.addEventListener('vt:uitvoering', function (e) {
  var det = e.detail || {};
  kies(det.handle || '');
});

function start() {
  var d = data();
  if (!d) return;
  if (d.start === 'model') { badges(d, 'model'); return; }
  var h = new URLSearchParams(location.search).get('uitvoering') || '';
  kies(h);
}

document.addEventListener('click', function (e) {
  var knop = e.target.closest && e.target.closest('[data-seo-meer]');
  if (!knop) return;
  var sectie = knop.closest('.vt-seo2');
  if (!sectie) return;
  if (!knop.dataset.meer) knop.dataset.meer = knop.textContent;
  var open = sectie.classList.toggle('is-open');
  knop.setAttribute('aria-expanded', String(open));
  knop.textContent = open ? knop.dataset.minder : knop.dataset.meer;
  if (!open) sectie.scrollIntoView({ block: 'start', behavior: stil ? 'auto' : 'smooth' });
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
document.addEventListener('shopify:section:load', start);
})();
